import { ArrowRight, Check } from "lucide-react";
import { Reveal } from "@/components/Reveal";
import { useAnchorNav } from "@/lib/nav";

const CtaSection = () => {
  const go = useAnchorNav();
  return (
    <section id="boka" className="relative overflow-hidden bg-orange py-20 sm:py-24">
      <div aria-hidden="true" className="absolute -left-24 -top-24 h-72 w-72 rounded-full border-[40px] border-cream/20" />
      <div aria-hidden="true" className="absolute -bottom-32 -right-16 h-80 w-80 rounded-full border border-navy/15" />
      <div className="relative mx-auto max-w-3xl px-5 text-center sm:px-8">
        <Reveal>
          <h2 className="font-display text-3xl font-extrabold tracking-tight text-navy sm:text-4xl">
            Redo att ta nästa steg digitalt?
          </h2>
          <p className="mx-auto mt-4 max-w-xl text-base leading-relaxed text-navy/75 sm:text-lg">
            Berätta vad du behöver hjälp med så tar vi kontakt och går igenom hur Tillvia kan hjälpa ditt företag.
          </p>
          <a
            href="#kontakt"
            data-testid="cta-section-button"
            onClick={(e) => go(e, "kontakt")}
            className="mt-8 inline-flex items-center gap-2 rounded-lg bg-navy px-8 py-4 font-display text-base font-bold text-cream shadow-xl shadow-navy/25 transition-[background-color,transform] duration-200 hover:-translate-y-0.5 hover:bg-navy2"
          >
            Boka kostnadsfritt möte <ArrowRight size={18} aria-hidden="true" />
          </a>
          <p className="mt-4 flex items-center justify-center gap-2 text-sm font-semibold text-navy/70">
            <Check size={16} aria-hidden="true" /> Kostnadsfritt & utan förpliktelser
          </p>
        </Reveal>
      </div>
    </section>
  );
};

export default CtaSection;
